import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IFavoriteRestaurant } from "../models/IFavoriteRestaurant";
import { getFavoriteRestaurants } from "../services/favoriteService";
import { S3_IMAGE_BASE_URL } from "../services/config";
import { useLanguage } from "../context/LanguageContext";
import "../styles/style.css";

function FavoriteRestaurants() {
  const [favorites, setFavorites] = useState<IFavoriteRestaurant[]>([]);
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    getFavoriteRestaurants()
      .then((res) => setFavorites(res.data))
      .catch(() => {});
  }, []);

  if (favorites.length === 0) return null;

  return (
    <section className="fav-restaurants">
      <h6 className="fav-restaurants__title">
        <i className="bi bi-heart-fill text-danger me-2"></i>
        {t("favorites.title")}
      </h6>
      <div className="fav-restaurants__scroll">
        {favorites.map((fav) => (
          <div
            key={fav.id}
            className="fav-restaurants__card"
            onClick={() => navigate(`/restaurants/${fav.restourantId}`)}
          >
            <div className="fav-restaurants__img">
              {fav.restourantLogoPath ? (
                <img
                  src={S3_IMAGE_BASE_URL + fav.restourantLogoPath}
                  alt={fav.restourantName}
                />
              ) : (
                <i className="bi bi-shop fav-restaurants__img-placeholder"></i>
              )}
            </div>
            <div className="fav-restaurants__info">
              <div className="fav-restaurants__name">{fav.restourantName}</div>
              {fav.restourantTotalFeedBackPoint > 0 && (
                <div className="fav-restaurants__rating">
                  <i className="bi bi-star-fill text-warning me-1"></i>
                  {fav.restourantTotalFeedBackPoint.toFixed(1)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FavoriteRestaurants;
